import Modal from "@mui/material/Modal";
import { IoCloseOutline } from "react-icons/io5";
import { BiUser } from "react-icons/bi";
import { useTranslation } from "react-i18next";

const Field = ({ label, value }) => (
  <div className="flex flex-col gap-1">
    <span className="text-[10px] font-semibold text-ui-text-subtle uppercase tracking-widest">{label}</span>
    <span className="text-sm text-ui-text">{value || "-"}</span>
  </div>
);

const Divider = ({ label }) => (
  <div className="col-span-3 mt-1 mb-0">
    <span className="text-xs font-semibold text-ui-text-muted">{label}</span>
  </div>
);

export default function ShipperUserDetails({ open, setOpen, data }) {
  const { t } = useTranslation("settings");
  const handleClose = () => setOpen(false);

  return (
    <Modal open={open} onClose={handleClose}>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-ui-surface rounded-xl shadow-2xl w-[780px] max-w-[95vw] flex flex-col outline-none">

        {/* Header */}
        <div className="flex items-center justify-between px-6 py-3 border-b border-ui-surface-sunken">
          <div className="flex items-center gap-2.5">
            <div className="w-8 h-8 rounded-full bg-brand-light flex items-center justify-center shrink-0">
              <BiUser size={16} className="text-brand" />
            </div>
            <h2 className="text-lg font-semibold text-ui-text m-0 leading-none">{t("helperUsers.detailsTitle")}</h2>
          </div>
          <button onClick={handleClose} className="text-ui-text-subtle hover:text-ui-text-muted transition-colors">
            <IoCloseOutline size={20} />
          </button>
        </div>

        {/* Body — 3 columns, no scroll needed */}
        <div className="px-5 py-4">
          <div className="grid grid-cols-3 gap-x-8 gap-y-5">

            <Divider label={t("helperUsers.identity")} />

            <Field label={t("fields.id")} value={data?.id} />
            <Field label={t("fields.username")} value={data?.username} />
            <Field label={t("fields.role")} value={data?.roles?.[0]?.name ?? data?.role} />
            <Field label={t("fields.firstName")} value={data?.firstname} />
            <Field label={t("fields.lastName")} value={data?.lastname} />
            <Field label={t("fields.email")} value={data?.email} />
            <Field label={t("fields.phoneNumber")} value={data?.phone_number} />

            <Divider label={t("helperUsers.location")} />

            <Field label={t("fields.address")} value={data?.address} />
            <Field label={t("fields.country")} value={data?.country} />
            <Field label={t("fields.province")} value={data?.province} />
            <Field label={t("fields.city")} value={data?.city} />
            <Field label={t("fields.postalZip")} value={data?.zip} />

          </div>
        </div>

        {/* Footer */}
        <div className="flex justify-end px-6 py-3 border-t border-ui-surface-sunken">
          <button
            onClick={handleClose}
            className="px-4 py-2 text-sm font-medium text-ui-text-muted bg-ui-surface-sunken rounded-lg hover:bg-ui-border transition-colors"
          >
            {t("common:actions.close")}
          </button>
        </div>

      </div>
    </Modal>
  );
}
